import {
  isProduction,
  isStage,
  isLocalHost
} from "@/src-refactor/modules/shared/helpers/check-environment";
import * as Sentry from "@sentry/react";
import { browserProfilingIntegration, replayIntegration } from "@sentry/react";
import ENVIRONMENT_VAR from "@/src-refactor/modules/shared/model/const/env/env.const";
export const initSentry = () => {
  const getSentryEnvironment = () => {
    return isProduction() ? "production" : "development";
  };
  const allowLocal = Boolean(ENVIRONMENT_VAR.SENTRY_ENABLE_LOCAL);
  if (ENVIRONMENT_VAR.SENTRY_DSN && (!isLocalHost() || allowLocal)) {
    const integrations = [browserProfilingIntegration()];

    if (isProduction()) {
      integrations.push(
        replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
          maskAllInputs: false
        })
      );
    }

    Sentry.init({
      dsn: ENVIRONMENT_VAR.SENTRY_DSN,
      environment: getSentryEnvironment(),
      release: ENVIRONMENT_VAR.VERSION,
      sendDefaultPii: true,
      tracesSampleRate: 1.0,
      integrations,
      // Session Replay (only enabled in production)
      replaysSessionSampleRate: isProduction() ? 0.1 : 0,
      replaysOnErrorSampleRate: isProduction() ? 1.0 : 0,
      enabled: true,
      beforeSend(event) {
        console.log("beforeSend", event);
        if (event.user) {
          // Sanitizar datos sensibles si es necesario
          delete event.user.authToken;
        }
        return event;
      }
    });

    // Exponer una API mínima en window para integraciones internas
    try {
      (
        window as unknown as {
          Sentry?: { captureMessage?: typeof Sentry.captureMessage };
        }
      ).Sentry = {
        captureMessage: Sentry.captureMessage
      };
    } catch {
      // no-op
    }
  }
};
